<template>
  <div class="file-upload">
    <el-form ref="form" :model="formState" :rules="rules" label-width="auto">
      <el-form-item v-if="isApply" label="附件上传:" :class="isAdvance ? 'not-required' : 'is-required'">
        <div class="file-upload_wrap">
          <div class="file-upload_content">
            <el-input v-model="attachmentDescription" placeholder="请输入附件说明" :disabled="disabled" :maxlength="10" />
            <el-upload
              action=""
              :disabled="!isCanUpload || disabled"
              multiple
              accept=".pdf, .xls, .xlsx, .jpg, .jpeg, .doc,.docx, .PDF, .XLS, .XLSX, .JPEG, .JPG, .DOC, .DOCX"
              :show-file-list="false"
              :http-request="handleUploadFile"
            >
              <el-button :disabled="!isCanUpload || disabled">
                上传
              </el-button>
            </el-upload>
          </div>
          <div class="description" title="上传格式: pdf、xls、xlsx、jpg、jpeg, word">
            上传格式: pdf、xls、xlsx、jpg、jpeg, word
          </div>
        </div>
      </el-form-item>
      <el-form-item label="已传附件:" class="upload_label" prop="uploadFileList" :class="isApply ? 'is-required not-required' : ''">
        <el-table
          v-loading="isUploading"
          border
          highlight-current-row
          :data="formState.uploadFileList"
          style="width: 100%"
          :row-key="row => row.fileToken"
        >
          <el-table-column prop="fileName" label="附件名称" align="left" min-width="100px">
            <template v-slot="{row}">
              <el-button type="text" @click="openOrDownLoad(row)">
                {{ row.fileName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="附件说明" align="left">
            <template v-slot:default="{row}">
              {{ row.description || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createByName" label="上传人" align="left">
            <template v-slot:default="{row}">
              {{ row.createByName || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" align="left">
            <template v-slot:default="{row}">
              {{ row.createTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="isApply" label="操作" align="left" fixed="right">
            <template v-slot:default="{row}">
              <el-popconfirm
                confirm-button-text="确定"
                cancel-button-text="取消"
                title="确认删除该文件吗?"
                placement="top"
                @confirm="handleRemoveFile(row)"
              >
                <template v-slot:reference>
                  <el-button type="text">
                    删除
                  </el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { attachmentGetToken, getUrlByFileID } from '@/API';
import dayjs from 'dayjs';
import AxiosApi from '@/API/fileAxios';
import { submitChangeUpload } from '@/API/international';
import { deepCopy } from '@/libs/util';

export default {
  name: 'FileUpload',
  props: {
    // 变更类型
    changeType: {
      type: String,
      default: ''
    },
    // 是否申请
    isApply: {
      type: Boolean,
      default: true
    },
    // 是否详情
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formState: {
        uploadFileList: []
      },
      isUploading: false,
      isCanUpload: true,
      isShowDeletePopup: false,
      attachmentDescription: void 0,
      fileToken: '',
      uploadUrl: '',
      downFileUrl: '',
      disabled: true
    };
  },
  computed: {
    isAdvance () {
      return this.changeType === 'advance';
    },
    rules () {
      if (this.isApply) {
        return {
          uploadFileList: [
            { required: !this.isAdvance, message: '请上传附件', trigger: 'change' }
          ]
        };
      } else {
        return {};
      }
    }
  },
  watch: {
    changeType (val) {
      this.disabled = !val;
    },
    rules: {
      handler (val) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      deep: true
    },
    attachmentDescription: {
      handler (value) {
        if (value) {
          this.isCanUpload = true;
        } else {
          this.isCanUpload = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取上传文件必要的参数
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fileToken = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((e) => {
        console.log(e);
      });
    },

    // 校验文件名是否非法
    checkSpecialCharacters (attachmentDescription) {
      // 规则对象(flag)
      const flag = new RegExp("[`~!@#$^&*=|{}':;',\\[\\]<>《》/?~！@#￥……&*——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      return flag.test(attachmentDescription);
    },
    // 校验文件是否是特定类型
    checkFileType (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      const typeList = ['pdf', 'xls', 'xlsx', 'jpg', 'jpeg', 'doc', 'docx'];
      return typeList.includes(fileType);
    },
    // 文件服务器上传
    handleUploadFile (upload) {
      if (!this.checkFileType(upload.file)) {
        this.$message.error('请正确上传文件！上传格式: pdf、xls、xlsx、jpg、jpeg, word');
        return;
      }
      if (upload.file.size > 1024 * 1024 * 500) {
        this.$message.error('文件大小不能超过500M！');
        return;
      }
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      this.isUploading = true;
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const file = {
        fileName: upload.file.name,
        description: this.attachmentDescription,
        createTime: dayjs(new Date()).format('YYYY-MM-DD')
      };
      this.formState.uploadFileList.push(file);
      AxiosApi.post(this.uploadUrl + `?Token=${this.fileToken}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          this.progress = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.handleAddFile({
            fileToken: json.data[0].FID,
            fileName: json.data[0].FullName,
            description: this.attachmentDescription
          });
        } else {
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        this.isUploading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },

    // 订单全流程保存上传记录
    handleAddFile (fileInfo) {
      submitChangeUpload(fileInfo).then((res) => {
        const json = res.data;
        this.formState.uploadFileList.pop();
        if (json.status === '200') {
          this.formState.uploadFileList.push(json.data);
          this.attachmentDescription = '';
          this.$message.success(`文件“${fileInfo.fileName}”,上传成功.`);
          this.$refs.form.validateField(['uploadFileList']);
        } else {
          this.$message.error(`文件“${fileInfo.fileName}”,上传失败.`);
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isUploading = false;
      });
    },
    openOrDownLoad (row) {
      getUrlByFileID(row.fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    },
    // 附件删除
    handleRemoveFile (row) {
      const index = this.formState.uploadFileList.findIndex(item => item.fileToken === row.fileToken);
      if (index !== -1) {
        this.formState.uploadFileList.splice(index, 1);
      }
    },
    setDefaultFormData (data) {
      this.formState.uploadFileList = deepCopy(data);
    },
    getFormData () {
      let isPass = false;
      this.$refs.form.validate((validate) => {
        isPass = validate;
      });
      if (!isPass) return false;
      return deepCopy(this.formState.uploadFileList.map(item => item.fileToken));
    }
  },
  mounted () {
    this.initToken();
  }
};
</script>

<style scoped lang="scss">
.file-upload {
  width: 100%;
  font-size: 14px;
  margin-top: 10px;
  .file-upload_wrap{
    display: flex;
    gap: 18px;
    align-items: center;
    margin-bottom: 12px;
    .file-upload_content{
      width: 700px;
      max-width: 700px;
      display: flex;
      gap: 18px;
      align-items: center;
      :deep(.el-input__inner) {
        min-width: 270px;
        max-width: 590px;
        flex: 1;
        height: 32px;
      }
      :deep(.el-button) {
        width: 92px !important;
        font-size: 14px !important;
        max-width: 92px !important;
        height: 30px !important;
        padding: 0 !important;
      }
    }
    .description {
      width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .not-required {
    :deep(.el-form-item__label){
      &:before {
        color: transparent !important;
      }
    }
  }
  .upload_label {
    :deep(.el-form-item__label) {
      line-height: 52px;
      font-size: 14px;
      white-space: nowrap;
    }
  }
}
.margin_bottom_30 {
  margin-bottom: 30px;
}
:deep(.el-button).is-disabled {
  background-color: #f5f5f5;
  border: #d9d9d9 solid 1px;
}
</style>
<style>
.el-popconfirm__main {
  margin-bottom: 12px;
}
</style>
